import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M14.5 12L9.5 7V17L14.5 12Z" xmlns="http://www.w3.org/2000/svg" />,
  "CaretRight"
);
